import * as Yup from "yup";

export const productsSchema = Yup.object().shape({
  // MÜTLƏQ OLANLAR
  name: Yup.string().required("Məhsulun adı tələb olunur"),
  category_id: Yup.number().required("Məhsulun kateqoriyası tələb olunur"),
  cover_image: Yup.string().required("Məhsulun şəkili tələb olunur"),

  // OPTIONAL FIELD-LƏR
  price: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),

  discount_price: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),

  description: Yup.string()
    .nullable()
    .transform((value) =>
      typeof value === "string" && value.trim() === "" ? null : value
    ),

  tracking_number: Yup.string()
    .nullable()
    .transform((value) =>
      typeof value === "string" && value.trim() === "" ? null : value
    ),

  model_code: Yup.string()
    .nullable()
    .transform((value) =>
      typeof value === "string" && value.trim() === "" ? null : value
    ),

  product_group: Yup.string()
    .nullable()
    .transform((value) =>
      typeof value === "string" && value.trim() === "" ? null : value
    ),

  warehouse_id: Yup.string()
    .nullable()
    .transform((value) =>
      typeof value === "string" && value.trim() === "" ? null : value
    ),
});
